export const LogoMark = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
    <rect width="32" height="32" rx="7" fill="#15171F" stroke="rgba(255,255,255,0.12)" />
    <rect x="7" y="8" width="18" height="3" rx="0.5" fill="#F2F0EA" />
    <rect x="7" y="14.5" width="12" height="3" rx="0.5" fill="#F2F0EA" />
    <rect x="7" y="21" width="6" height="3" rx="0.5" fill="#F2F0EA" />
    <circle cx="22.5" cy="22.5" r="2.6" fill="#E8B04B" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="font-display text-[17px] font-semibold tracking-tight text-ink">
      Extra<span className="text-gold">Value</span>
    </span>
  </span>
);
